import React from "react";

const DatabaseIcon = ({ color = "#0A61F5" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 2.375H5C4.66848 2.375 4.35054 2.5067 4.11612 2.74112C3.8817 2.97554 3.75 3.29348 3.75 3.625V17.375C3.75 17.7065 3.8817 18.0245 4.11612 18.2589C4.35054 18.4933 4.66848 18.625 5 18.625H15C15.3315 18.625 15.6495 18.4933 15.8839 18.2589C16.1183 18.0245 16.25 17.7065 16.25 17.375V3.625C16.25 3.29348 16.1183 2.97554 15.8839 2.74112C15.6495 2.5067 15.3315 2.375 15 2.375ZM15 3.625V7.375H5V3.625H15ZM5 12.375V8.625H15V12.375H5ZM5 17.375V13.625H15V17.375H5Z"
        fill={color}
      />
      <path
        d="M6.875 6.125C7.22018 6.125 7.5 5.84518 7.5 5.5C7.5 5.15482 7.22018 4.875 6.875 4.875C6.52982 4.875 6.25 5.15482 6.25 5.5C6.25 5.84518 6.52982 6.125 6.875 6.125Z"
        fill={color}
      />
      <path
        d="M6.875 11.125C7.22018 11.125 7.5 10.8452 7.5 10.5C7.5 10.1548 7.22018 9.875 6.875 9.875C6.52982 9.875 6.25 10.1548 6.25 10.5C6.25 10.8452 6.52982 11.125 6.875 11.125Z"
        fill={color}
      />
      <path
        d="M6.875 16.125C7.22018 16.125 7.5 15.8452 7.5 15.5C7.5 15.1548 7.22018 14.875 6.875 14.875C6.52982 14.875 6.25 15.1548 6.25 15.5C6.25 15.8452 6.52982 16.125 6.875 16.125Z"
        fill={color}
      />
    </svg>
  );
};

export default DatabaseIcon;
